import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const dealOfTheDayApi = createApi({
  reducerPath: 'dealOfTheDayApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token') || localStorage.getItem('vendor_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['DealOfTheDay'],
  endpoints: (build) => ({
    // List all deals of the day
    listDealsOfTheDay: build.query({
      query: () => ({
        url: 'user/Listdeals',
        method: 'POST',
        body: {},
      }),
      providesTags: ['DealOfTheDay'],
    }),
    
    // Add new deal
    addDeal: build.mutation({
      query: (dealData) => {
        // Backend expects these fields
        // Validation: if (!product_id || !start_date || !end_date)
        const payload = {
          product_id: Number(dealData.product_id),
          start_date: dealData.start_date,
          end_date: dealData.end_date,
          discount: Number(dealData.discount || 0),
          status: Number(dealData.status || 1),
        };

        console.log('API Add Deal Payload:', payload);
        
        return {
          url: 'user/adddeal',
          method: 'POST',
          body: payload,
        };
      },
      invalidatesTags: ['DealOfTheDay'],
    }),
    
    // Update existing deal
    updateDeal: build.mutation({
      query: (dealData) => {
        // Backend expects these exact fields in this structure
        // Validation: if (!deal_id || !product_id || !start_date || !end_date)
        const payload = {
          deal_id: Number(dealData.deal_id),
          product_id: Number(dealData.product_id),
          start_date: dealData.start_date,
          end_date: dealData.end_date,
          discount: Number(dealData.discount),
          status: Number(dealData.status),
        };

        console.log('API Update Deal Payload:', payload);
        console.log('Required fields check:');
        console.log('  deal_id:', payload.deal_id, '(required)');
        console.log('  product_id:', payload.product_id, '(required)');
        console.log('  start_date:', payload.start_date, '(required)');
        console.log('  end_date:', payload.end_date, '(required)');
        console.log('  discount:', payload.discount);
        console.log('  status:', payload.status);
        
        return {
          url: 'user/updatedeal',
          method: 'POST',
          body: payload,
        };
      },
      invalidatesTags: ['DealOfTheDay'],
    }),
    
    // Delete deal of the day
    deleteDealOfTheDay: build.mutation({
      query: (id) => {
        console.log('Delete Deal - Received ID:', id, 'Type:', typeof id);
        
        // Ensure id is a valid number
        const dealId = Number(id);
        
        if (!dealId || isNaN(dealId)) {
          console.error('Invalid deal ID provided:', id);
          throw new Error(`Invalid deal ID: ${id}`);
        }
        
        // API expects 'deal_id' parameter, not 'id'
        const payload = { deal_id: dealId };
        console.log('Delete Deal Payload:', payload);
        
        return {
          url: 'user/deletedeal',
          method: 'POST',
          body: payload,
        };
      },
      invalidatesTags: ['DealOfTheDay'],
    }),
  }),
});

export const {
  useListDealsOfTheDayQuery,
  useAddDealMutation,
  useUpdateDealMutation,
  useDeleteDealOfTheDayMutation,
} = dealOfTheDayApi;